<template>
  <div class="Login">
    <div class="title_content">
      <div class="font"></div>
      <div class="ligtht"></div>
    </div>
    <!--   <div class="secTitle"></div> -->
    <div class="msgContent">
      <div class="assect">
        <input type="text" v-model="account" placeholder="请输入账号" />
        <div class="icon"></div>
      </div>
      <div class="password">
        <input
          type="password"
          v-model="password"
          placeholder="请输入密码"
          @keyup.enter="keydown_login"
        />
        <div class="icon"></div>
      </div>
      <div class="rememberPassword">
        <div class="remember">
          <div class="icon" @click="autoClick">
            <img src="../assets/images/Login/remember-icon.png" alt="" v-if="auto" />
          </div>
          <div class="text">
            {{ '记住密码' }}
          </div>
        </div>
      </div>
      <div class="log" @click="keydown_login">
        {{ '登录' }}
      </div>
    </div>
  </div>
</template>
<script setup>
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useOverViewStore } from '@/store/index';
import { storeToRefs } from 'pinia';

const routTypeIndex = ref(0);
const routeTap = ref([
  {
    name: 'pc端',
    router: '/index',
  },
  {
    name: '控制端',
    router: '/Controler',
  },
]);
const changeRouteTap = (index) => {
  routTypeIndex.value = index;
};

const btnArr = ref([
  {
    name: 'En',
    bE: true,
  },
  {
    name: '中',
    bE: false,
  },
]);

const router = useRouter();
let auto = ref(false);
const account = ref('admin');
const password = ref('123456');
const captchaPic = ref(null);
const uuid = ref();
const captchaVal = ref(null);

function autoClick() {
  auto.value = !auto.value;
}

const login = async () => {
  let row = {
    account: account.value,
    password: password.value,
  };

  if (account.value === 'admin' && password.value == 123456) {
    router.push({
      path: '/beginAnimation',
    });
  } else {
    tips('账号/密码错误', 1500, 'error');
  }
};
//弹窗工具
function tips(text, time, type) {
  var scale = window.document.documentElement.clientWidth / 1920;
  time = time ? time : 1500;
  var backgroundColor, color;
  switch (type) {
    case 'error':
      backgroundColor = 'rgb(254, 240, 240)';
      color = 'rgb(246, 124, 124)';
      break;
    case 'success':
      backgroundColor = 'rgb(240, 249, 235)';
      color = 'rgb(118, 200, 77)';
      break;
    default:
      backgroundColor = 'rgb(237, 242, 252)';
      color = 'rgb(160, 164, 171)';
  }
  var para = document.createElement('div'); //创建新的<p> 元素
  para.innerHTML = text;
  para.className = 'tips';
  para.style.display = 'inline-block';
  para.style.textAlign = 'center';
  para.style.backgroundColor = backgroundColor;
  para.style.color = color;
  para.style.fontSize = '25px';
  para.style.borderRadius = '10px';
  para.style.padding = '15px 25px';
  para.style.zIndex = 10000;
  para.style.wordBreak = 'break-word';
  para.style.position = 'absolute';

  document.body.appendChild(para);

  for (var i = 0; i < document.getElementsByClassName('tips').length; i++) {
    document.getElementsByClassName('tips')[i].style.top =
      ((1080 * scale - para.offsetHeight) / 10) * scale -
      70 * scale * (document.getElementsByClassName('tips').length - 1 - i) +
      'px';
  }
  para.style.left = (1920 * scale - para.offsetWidth) / 2 + 'px';

  para.timer = setTimeout(function () {
    clearInterval(para.timer);
    document.body.removeChild(para);
  }, time);
}

const keydown_login = () => {
  login();
};

onMounted(() => {});
</script>

<style lang="scss" scoped>
.Login {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9;
  width: 1920px;
  height: 1080px;
  background-size: 100% 100%;
  background-image: url(../assets/images/Login/bg.png);

  .tapArrContent {
    position: absolute;
    left: 20px;
    top: 10px;
    width: 70px;
    height: 70px;
    .item {
      width: 70px;
      height: 35px;
      text-align: center;

      font-family: 'MiSans';
      font-size: 23.333px;
      font-style: normal;
      font-weight: 400;
      line-height: 35px;
      cursor: pointer;
      color: #000;
      background-color: #fff;

      &.active {
        color: #fff;
        background-color: skyblue;
      }
    }
  }
  .title_content {
    position: absolute;
    left: 1456.25px;
    top: 430px;
    width: 454.63px;
    height: 47px;
    background-size: 100% 100%;
    background-image: url(@/assets/images/Login/font.png);

    .ligtht {
      position: absolute;
      z-index: 0;
      left: 50%;
      top: -45px;
      transform: translate(-50%, 0);
      width: 534px;
      height: 187px;
      background-size: 100% 100%;
      background-image: url(../assets/images/Login/light.png);
    }
  }
  .msgContent {
    position: absolute;
    right: 249px;
    bottom: 456px;
    transform: translate(-50%, 0);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    .assect {
      width: 477.22px;
      height: 65.43px;
      display: block;
      position: relative;
      padding: 14px 63px 9px;
      box-sizing: border-box;
      background: rgba(1, 93, 229, 0);
      border: 0px solid #005cba;
      background-size: 100% 100%;
      background-image: url(../assets/images/Login/input-bg3.png);
      margin-bottom: 12px;

      > input {
        position: absolute;
        left: 0px;
        top: 0px;
        width: 477.22px;
        height: 65.43px;
        padding: 14px 63px 9px;
        box-sizing: border-box;
        background: transparent;
        border: transparent;
        font-family: 'OPPOSans';
        font-style: normal;
        font-weight: 400;
        font-size: 23.9956px;
        line-height: 32px;
        /* identical to box height */
        letter-spacing: 0.04em;
        color: #fff;
      }
      .icon {
        position: absolute;
        z-index: 1;
        left: 21px;
        top: 20px;
        width: 17px;
        height: 20px;
        background-size: 100% 100%;
        background-image: url(../assets/images/Login/Vector.png);
        opacity: 0.6;
      }
    }
    .password {
      width: 477.22px;
      height: 65.43px;
      display: block;
      position: relative;
      padding: 14px 63px 9px;
      box-sizing: border-box;
      font-family: 'OPPOSans';
      font-style: normal;
      font-weight: 400;
      font-size: 23.9956px;
      line-height: 32px;
      /* identical to box height */
      letter-spacing: 0.04em;
      color: #fff;
      background: rgba(1, 93, 229, 0);
      border: 0px solid #005cba;
      background-size: 100% 100%;
      background-image: url(../assets/images/Login/input-bg3.png);
      margin-bottom: 22px;

      > input {
        position: absolute;
        left: 0px;
        top: 0px;
        width: 477.22px;
        height: 65.43px;
        padding: 14px 63px 9px;
        box-sizing: border-box;
        background: transparent;
        border: transparent;
        font-family: 'OPPOSans';
        font-style: normal;
        font-weight: 400;
        font-size: 23.9956px;
        line-height: 32px;
        /* identical to box height */
        letter-spacing: 0.04em;
        color: #fff;
      }
      .icon {
        position: absolute;
        left: 21px;
        top: 20px;
        width: 17px;
        height: 20px;
        background-size: 100% 100%;
        background-image: url(../assets/images/Login/icon_password.png);
        opacity: 0.6;
      }
    }
    .password:hover,
    .assect:hover {
      // opacity: 0.6;
      .icon {
        opacity: 1;
      }
    }
    .captcha {
      width: 477.22px;
      height: 65.43px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      .captchaIp {
        width: 237px;
        height: 65.43px;
        display: block;
        position: relative;
        padding: 14px 20px 9px 63px;
        box-sizing: border-box;
        background: rgba(1, 93, 229, 0);
        border: 0px solid #005cba;
        background-size: 100% 100%;
        background-image: url(../assets/images/Login/input-bg2.png);
        margin-bottom: 4px;

        > input {
          position: absolute;
          left: 0px;
          top: 0px;
          width: 100%;
          height: 100%;
          padding: 14px 20px 9px 63px;
          box-sizing: border-box;
          background: transparent;
          border: transparent;
          font-family: 'OPPOSans';
          font-style: normal;
          font-weight: 400;
          font-size: 23.9956px;
          line-height: 32px;
          /* identical to box height */
          letter-spacing: 0.04em;
          color: #fff;
        }
        .icon {
          position: absolute;
          z-index: 1;
          left: 21px;
          top: 20px;
          width: 17px;
          height: 20px;
          background-size: 100% 100%;
          background-image: url(../assets/images/Login/icon_account.png);
          opacity: 0.6;
        }
      }
      .captchaIp:hover {
        // opacity: 0.6;
        .icon {
          opacity: 1;
        }
      }
      .captchaBox {
        cursor: pointer;
        width: 136.5px;
        height: 49px;
        background: rgba(1, 93, 229, 0.15);
        border: 1px solid rgba(2, 67, 133, 0.8);
        .pic {
          cursor: pointer;
          width: 100%;
          height: 100%;
        }
      }
    }
    .rememberPassword {
      cursor: pointer;
      width: 100%;
      height: 18px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 38px;
      .remember {
        display: flex;
      }
      .icon {
        cursor: pointer;
        width: 16px;
        height: 16px;
        margin-right: 9px;
        background-size: 100% 100%;
        background-image: url(../assets/images/Login/remember.png);
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .icon.active {
        background-image: url(../assets/images/Login/selected.png);
      }
      .text {
        font-family: 'OPPOSans';
        font-style: normal;
        font-weight: 400;
        font-size: 13.9983px;
        line-height: 18px;
        color: #ffffff;
      }
    }
    .log {
      cursor: pointer;
      width: 477.22px;
      height: 65.43px;
      text-align: center;
      padding: 19px 10px 12px;
      box-sizing: border-box;
      font-family: 'OPPOSansB';
      font-style: normal;
      font-weight: 400;
      font-size: 17.9967px;
      line-height: 24px;
      color: #ffffff;
      // opacity: 0.8;
      margin-bottom: 13px;
      background-size: 100% 100%;
      background-image: url(../assets/images/Login/submit.png);
    }
    .log:hover {
      opacity: 1;
    }
  }
  .forgetPassworld {
    cursor: pointer;
    // position: absolute;
    // left: 1087.94px;
    // top: 499px;
    width: 56px;
    font-family: 'OPPOSans';
    font-style: normal;
    font-weight: 400;
    font-size: 13.9983px;
    line-height: 18px;

    color: #ffffff;
  }

  input::-webkit-input-placeholder {
    font-family: 'OPPOSans';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
  }
  .english_tap_content {
    position: absolute;
    top: 756px;
    left: 1153px;
    display: flex;
    justify-content: space-between;
    width: 350.61px;
    align-items: center;
    .item {
      cursor: pointer;
      width: 161.0392608642578px;
      height: 47.865570068359375px;
      background-size: 100% 100%;
      background-image: url(../assets/images/Login/tap_nor.png);
      text-align: center;
      color: #fff;
      font-family: MiSans;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: 47.865570068359375px;

      &.active {
        width: 157.611px;
        height: 50.348px;
        background-image: url(../assets/images/Login/tap_act.png);
        color: #f0f4fd;
        text-shadow: 0px 2.8606481552124023px 4.2909722328186035px rgba(3, 16, 43, 0.4);
        font-family: MiSans;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 50.348px;
      }
    }
  }
}
</style>
